var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"normal-layout-container"},[_c('div',{staticClass:"normal-layout-banner",style:(_vm.getBannerImageBackgroundStyle)},[(_vm.getBannerImageForeground)?_c('img',{attrs:{"src":_vm.getBannerImageForeground}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"normal-layout-header"},[_vm._t("header")],2)]),_vm._v(" "),_vm._t("body")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e98b34a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/NormalLayout.vue
// module id = null
// module chunks = 